<ng-template let-item="item">
    <span class="font-weight-bold">{{ 'side_filter.my_filters_button' | translate }}</span>
</ng-template>
